import React from 'react';
import { ArrowRight, Anchor, CloudRain, Warehouse, CheckCircle, Lock } from 'lucide-react';
import SEO from '../components/SEO';

const EnclosedBoatRVStorage = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <SEO
                title="Enclosed Boat & RV Storage Near Richland Chambers Lake | V&D Storage"
                description="Premier indoor enclosed boat and RV storage near Richland Chambers Lake. Protection from sun, hail, and Texas weather. Wide 12-foot doors, concrete floors."
                canonical="/enclosed-boat-rv-storage-streetman"
            />
            {/* Hero Section */}
            <section className="bg-gray-900 text-white py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h1 className="text-4xl md:text-5xl font-bold mb-6">
                        Premier Indoor Boat & RV Storage
                        <span className="block text-green-500 mt-2">at Richland Chambers</span>
                    </h1>
                    <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">
                        Protect your investment from Sun, Hail, and Weather.
                        Don't let the Texas weather ruin your gel coat or roof.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a
                            href="https://vdstoragestreetman.storageunitsoftware.com/pages/rent"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                if (window.gtag) {
                                    window.gtag('event', 'conversion_intent', {
                                        'event_category': 'lead',
                                        'event_label': 'enclosed_hero_reserve',
                                        'facility_name': 'VD Storage Streetman'
                                    });
                                }
                            }}
                            className="inline-flex items-center px-8 py-3 text-lg font-semibold text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors shadow-lg"
                        >
                            Reserve Enclosed Unit
                            <ArrowRight className="ml-2 h-5 w-5" />
                        </a>
                    </div>
                </div>
            </section>

            {/* The Garage Experience */}
            <section className="py-16 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-3xl mx-auto">
                        <h2 className="text-3xl font-bold text-gray-900 mb-6">
                            The "Garage" Experience
                        </h2>
                        <p className="text-xl text-gray-700 leading-relaxed mb-6">
                            Keep your vehicle showroom-ready in our fully enclosed units. It's not just storage;
                            it's a private garage for your lake toys.
                        </p>
                        <ul className="space-y-4">
                            <li className="flex items-start">
                                <Warehouse className="h-6 w-6 text-green-600 mr-3 mt-1" />
                                <div>
                                    <h4 className="font-bold text-gray-900">Wide 12' Doors</h4>
                                    <p className="text-gray-600">Easy maneuverability for large rigs.</p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <CloudRain className="h-6 w-6 text-green-600 mr-3 mt-1" />
                                <div>
                                    <h4 className="font-bold text-gray-900">100% Weather Protection</h4>
                                    <p className="text-gray-600">Shielded from sun, rain, and hail damage.</p>
                                </div>
                            </li>
                            <li className="flex items-start">
                                <Lock className="h-6 w-6 text-green-600 mr-3 mt-1" />
                                <div>
                                    <h4 className="font-bold text-gray-900">Concrete Floors</h4>
                                    <p className="text-gray-600">Clean, dust-free environment for your vehicle.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Weather Warning */}
            <section className="py-16 bg-red-50 border-t border-b border-red-100">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-2xl font-bold text-red-800 mb-4">
                        Don't Risk Sun & Hail Damage
                    </h2>
                    <p className="text-lg text-red-700">
                        Texas weather is unpredictable. One hailstorm can cause thousands in damages.
                        Enclosed storage pays for itself by protecting your asset's resale value.
                    </p>
                </div>
            </section>

            {/* Footer Option */}
            <section className="py-12 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p className="text-gray-600 mb-4">Looking for something simpler?</p>
                    <p className="font-medium text-gray-900">
                        We also offer secure outdoor parking for trailers.
                        <a href="/contact" className="text-green-600 hover:text-green-700 ml-2 underline">
                            Contact us for availability.
                        </a>
                    </p>
                </div>
            </section>
        </div>
    );
};

export default EnclosedBoatRVStorage;
